// extracted by mini-css-extract-plugin
export var text = "_3d-0";